import { render, staticRenderFns } from "./FaseCultivoList.vue?vue&type=template&id=66f3f1bd&scoped=true"
import script from "./FaseCultivoList.vue?vue&type=script&lang=js"
export * from "./FaseCultivoList.vue?vue&type=script&lang=js"
import style0 from "./FaseCultivoList.vue?vue&type=style&index=0&id=66f3f1bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f3f1bd",
  null
  
)

export default component.exports